import ApiService from '@boServices/apiService';

class TestService extends ApiService {
    /** Tests whose reference or title holds each word of `search`, ordered by reference: `limit` of them at most (50 at most). */
    searchTests({ search = '', limit = 20, signal } = {}) {
        const params = new URLSearchParams({ limit: String(limit) });
        if (search) params.set('search', search);
        return this.fetchWithHeaders(`/api/v2/backoffice/tests?${params.toString()}`, 'GET', { signal });
    }

    getTest(reference) {
        return this.fetchWithHeaders(`/api/v2/backoffice/tests/${encodeURIComponent(reference)}`, 'GET');
    }
}

export default TestService;
